import { Roboto } from 'next/font/google'

import TENANTS from '@/consts/tenants'
import { type TenantsType } from '@/consts/setupApp/tenants'
const {
  cbank,
  cbroker,
  hsp,
  prescientsecurity1,
  myv,
  demo_cl,
  supv,
  casanuestra,
  demo_ar,
  maf,
  supv_sme
} = TENANTS
const roboto = Roboto({ subsets: ['latin'], weight: ['100', '300', '400', '500', '700'] })

const FONTS_BY_TENANT: {
  [key: string]: {
    className: string
    style: {
      fontFamily: string
      fontWeight?: number
      fontStyle?: string
    }
  }
} = {
  [hsp]: roboto,
  [cbank]: roboto,
  [cbroker]: roboto,
  [prescientsecurity1]: roboto,
  [myv]: roboto,
  [maf]: roboto,
  [demo_cl]: roboto,
  [supv]: roboto,
  [supv_sme]: roboto,
  [casanuestra]: roboto,
  [demo_ar]: roboto
}

const DEFAULT_FONTS = roboto

export default function getAppFont(tenant: TenantsType) {
  return FONTS_BY_TENANT[tenant] || DEFAULT_FONTS
}
